// extracted by mini-css-extract-plugin
export default {"tip":"UpdateSelf_tip__PYsk9","updateSelf":"UpdateSelf_updateSelf__iuH2u"};